import './public-path';
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import BaseApp from './BaseApp';

const render = (props) => {
  const { container = document.body } = props;
  const mountedNode = container.querySelector('#app');
  const router = createBrowserRouter([{ path: '/*', element: <BaseApp container={container} /> }]);
  const root = createRoot(mountedNode);
  root.render(<RouterProvider router={router} />);
};

render({});
